import React, { type FC } from 'react';
// import { Button } from 'layout/Button';
import { UtilityChip } from '@components/utilityChip';
import { ToBuildingViewButton } from '@components/ToBuildingViewButton';
import StatusChipPill from '@components/statusChip/StatusChipPill';
import { type Meter } from 'interfaces/assets/Meters.interface';
import Skeleton from 'react-loading-skeleton';
import { StatusEnum } from 'enums/StatusEnum';
import { removeUnderscoreAndCapitalize } from 'utils/formatters/string/stringFormatter';
import LegallyRequiredBadge from './LegallyRequiredBadge';

// Enum to map effort keys to readable names
export enum EffortLabelEnum {
  QUICK_WIN = 'Quick win',
  STRUCTURE_OPTIMIZATION = 'Structure optimization',
}

const EnergyAuditHeader: FC<{
  data?: Meter;
  isFetching?: boolean;
  isLegallyRequired?: boolean;
  auditCategory?: string;
  effort?: string;
}> = ({
  data,
  isFetching,
  isLegallyRequired = false,
  auditCategory,
  effort,
}) => {
  const asset = data?.assets?.[0];
  // Helper to cast status string to StatusEnum if possible
  const getStatusEnum = (status?: string): StatusEnum | undefined => {
    if (!status) return undefined;
    return Object.values(StatusEnum).includes(status as StatusEnum)
      ? (status as StatusEnum)
      : undefined;
  };
  return (
    <div className="flex flex-col gap-2">
      <div className="flex justify-between items-center">
        <div className="flex items-center gap-4">
          <h1 className="text-2xl font-extrabold leading-7 text-gray-60 font-heading">
            {isFetching ? (
              <Skeleton width={200} />
            ) : (
              removeUnderscoreAndCapitalize(auditCategory)
            )}
          </h1>
          <div className="flex gap-2">
            {isFetching ? (
              <Skeleton width={80} height={28} />
            ) : (
              <UtilityChip utility={data?.utility_type} />
            )}
            {isFetching ? (
              <Skeleton width={80} height={28} />
            ) : getStatusEnum(asset?.status) ? (
              <StatusChipPill
                status={getStatusEnum(asset?.status) as StatusEnum}
              />
            ) : null}
          </div>
        </div>
      </div>
      <div className="flex gap-2 text-sm mt-1">
        {isFetching ? (
          <Skeleton width={180} />
        ) : (
          <ToBuildingViewButton name={asset?.name ?? ''} id={asset?.id} />
        )}
        <span className="text-gray-60/10">{' | '}</span>

        <span className="text-gray-50 font-sans">
          {isFetching ? <Skeleton width={80} /> : data?.name}
        </span>
      </div>
      <div className="flex items-center gap-2 text-sm mt-1">
        {/* <div className="flex gap-2 items-center">
          {isFetching ? (
            <Skeleton width={80} />
          ) : (
            <span className="text-gray-60 font-medium font-sans">
              {'Category:'}
            </span>
          )}

          {isFetching ? (
            <Skeleton width={80} />
          ) : (
            <span className="text-gray-50 font-sans">{data?.name}</span>
          )}
        </div> */}

        {/* <span className="text-gray-60/10">{' | '}</span> */}
        <div className="flex gap-2 items-center">
          {' '}
          {isFetching ? (
            <Skeleton width={60} />
          ) : (
            <span className="text-gray-60 font-medium font-sans">
              {'Effort:'}
            </span>
          )}
          {isFetching ? (
            <Skeleton width={80} />
          ) : (
            <span className="text-gray-50 font-sans">
              {effort ? (
                EffortLabelEnum[
                  effort
                    ?.toUpperCase()
                    .replace(' ', '_') as keyof typeof EffortLabelEnum
                ] || effort
              ) : (
                <Skeleton width={80} />
              )}
            </span>
          )}
        </div>

        {isLegallyRequired && <LegallyRequiredBadge />}
      </div>
    </div>
  );
};

export default EnergyAuditHeader;
